import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';

export const useMarkManualPaymentRefunded = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const apiClient = useApiClient();
    return useMutation({
        mutationFn: async (paymentIntentId: string) => {
            return apiClient.fetchApi<{ success: boolean }, void>({
                endpoint: `payments/mark-manual-payment-refunded/${paymentIntentId}`,
                method: 'POST',
            });
        },
        onSuccess: () => {
            toast({
                title: translate('game.mark_refunded_success'),
                status: 'success',
                duration: 5000,
                isClosable: true,
            });
            queryClient.invalidateQueries({ queryKey: ['game'] });
        },
        onError: (error: any) => {
            toast({
                title: translate('game.mark_refunded_error'),
                description: error?.message || translate('common.unexpected_error'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
